

















































import ItemPreview from "./item-preview.vue";

export default {
	components: {
		ItemPreview
	},
	props:{
		data:{
			type:Object,
			required:true
		}
	},
	data(){
		return {
			show:false
		}
	},
	methods:{
		open(){
			this.show = true;
		}
	}
}

